import { Select, MenuItem, FormControl, InputLabel, Box, Typography } from '@mui/material';

const TimeFrameSelect = ({timeframe, setTimeframe, label}) => {
    const getMainLabel = (value) => {
        switch(value) {
            case 1: return 'Last Week';
            case 2: return 'Last Month';
            case 3: return 'Last Quarter';
            case 4: return 'Last Year';
            default: return '';
        }
    };

    return <FormControl sx={{ width: { md: "100%", lg: 250 }, minWidth: 250 , my: { sm: 3, md: 0 } }}>
    <InputLabel id="timeframe-select-label">Timeframe</InputLabel>
    <Select
        labelId="timeframe-select-label"
        value={timeframe}
        label={label}
        onChange={(e) => setTimeframe(e.target.value)}
        renderValue={(value) => (
            <Typography>{getMainLabel(value)}</Typography>
        )}
    >
        <MenuItem value={1}>
          <Box>
            <Typography>Last Week</Typography>
            <Typography variant='body2' sx={{ color: 'text.secondary', mt: 0.5 }}>Last 7 days</Typography>
          </Box>
        </MenuItem>
        <MenuItem value={2}>
          <Box>
            <Typography>Last Month</Typography>
            <Typography variant='body2' sx={{ color: 'text.secondary', mt: 0.5 }}>Last 30 days</Typography>
          </Box>
        </MenuItem>
        <MenuItem value={3}>
          <Box>
            <Typography>Last Quarter</Typography>
            <Typography variant='body2' sx={{ color: 'text.secondary', mt: 0.5 }}>Last 90 days</Typography>
          </Box>
        </MenuItem>
        <MenuItem value={4}>
          <Box>
            <Typography>Last Year</Typography>
            <Typography variant='body2' sx={{ color: 'text.secondary', mt: 0.5 }}>Last 365 days</Typography>
          </Box>
        </MenuItem>
        {/* <MenuItem value={5}>All Time</MenuItem> */}
    </Select>
    </FormControl>
}

export default TimeFrameSelect;